import React from 'react';
import { Alert, Button, Col, Row } from '@nackle/origami';
import { getString, LocaleString } from '@nackle/intl-tools';
import { routeHistory } from '@nackle/biw-web-router';

import './error-display.less';

export default class ErrorDisplay extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            errorText: []
        };
    }
    static getDerivedStateFromProps( nextProps, prevState ) {
        if ( nextProps.errors && nextProps.errors.length > 0 ) {

            const uniqueErrors = nextProps.errors.reduce( ( error, o ) => {
                if ( !error.some( obj => obj.code === o.code ) ) {
                    error.push( o );
                }
                return error;
            }, [] );

            return { errorText: uniqueErrors };
        }
        return { errorText: [] };
    }

    shouldComponentUpdate( nextProps, nextState ) {

        if ( this.props.path !== nextProps.path ) {
            this.props.clearError();
            this.setState( { errorText: '' } );
        }
        return true;
    }

    handleActive = ( e ) => {
        if ( this.props.path === '/door/activate' ) {
            this.props.clearError();
        } else {
            routeHistory.push( '/door/activate' );
        }
    };

    handleLoginClick = async ( e ) => {
        const { getPrimaryExperienceUrl } = this.props;
        let primaryExperienceUrl = null;
        try {
            primaryExperienceUrl = await getPrimaryExperienceUrl();
        } catch ( err ) {
            console.error( 'error when fetching primary exp', err );
        }
        
        window.location.href = primaryExperienceUrl || '/door/error';
    };

    render() {
        const { errorText } = this.state;

        // Check if the error code is already activated one , so we can show respective CTA's
        const isAlreadyActivatedAccountError = errorText.find( error => error.code === 'activation.error.activatedAccount' );
        const isActivationInValidLinkError = errorText.find( error => error.code === 'activation.error.invalidLink' );
        const isResetPasswordInValidLinkError = errorText.find( error => error.code === 'setPassword.error.invalidLink' ) && this.props.path !== '/door/set-password';
        const isPasswordExpired = errorText.find( error => error.code === 'login.error.passwordExpired' );

        const ActivationCTA = <Button
            id="activate"
            data-testid="activate"
            shape="round"
            type="primary"
            className="primary-background primary-border"
            onClick={ this.handleActive }>
            <LocaleString code="activate.form.headerLabel" />
        </Button>;

        const LoginCTA = <Button
            id="login"
            data-testid="login"
            shape="round"
            type="primary"
            className="primary-background primary-border"
            onClick={ this.handleLoginClick }>
            <LocaleString code="login.button.submitLabel" />
        </Button>;

        const ForgotPasswordCTA = <Button
            id="forgot-password"
            data-testid="forgot-password"
            shape="round"
            type="primary"
            className="primary-background primary-border"
            onClick={ () => routeHistory.push( '/door/forgot-password' ) }>
            <LocaleString code="forgotPassword.form.headerLabel" />
        </Button>;

        const PasswordCTA = <Button
            id="set-password"
            shape="round"
            type="primary"
            className="primary-background primary-border"
            onClick={ () => routeHistory.push( '/door/update-password' ) }>
            <LocaleString code="updatePassword.submitButton.label" />
        </Button>;

        return (
            <div className="errorAlert">
                { errorText.length > 0 &&
                    <div className="error-form">
                        { errorText.map( error => {
                            return (
                                <Alert
                                    aria-label={ getString( error.code, error.data ? { ...error.data } : null ) }
                                    key={ error.code }
                                    type='error'
                                    message={ error.message && <LocaleString code={ error.message } /> }
                                    description={ <LocaleString code={ error.code } replaceOptions={ error.data ? error.data : null }/> }
                                    showIcon/>
                            );
                        } ) }
                    </div>
                }
                { isAlreadyActivatedAccountError &&
                    <Row>
                        <Col span={ 11 }> { LoginCTA } </Col>
                        <Col span={ 11 } offset={ 2 }> { ActivationCTA } </Col>
                    </Row>
                }
                {
                    isActivationInValidLinkError && ActivationCTA
                }
                {
                    isResetPasswordInValidLinkError && ForgotPasswordCTA
                }
                {
                    isPasswordExpired ? PasswordCTA : <></>
                }
            </div>
        );
    }
}